import { render, staticRenderFns } from "./MaintainerUsers.vue?vue&type=template&id=ff716080&scoped=true&"
import script from "./MaintainerUsers.vue?vue&type=script&lang=js&"
export * from "./MaintainerUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff716080",
  null
  
)

export default component.exports